export const SystemLogKeys = {
  getEvents: 'systemLog/getEvents',
  syslogEvent: (id: string) => ['systemLog/syslogEvent', id],
  actions: 'systemLog/actions',
  sources: 'systemLog/sources',
  actors: 'systemLog/actors',
  targetTypes: 'systemLog/targetTypes',
  targets: 'systemLog/targets',
} as const;
